<template>
    <div class="ProseMirror rendered-content" v-html="rendered_html"></div>
</template>

<script lang="ts" setup>
import type { JSONContent } from "@tiptap/vue-3"
import { generateHTML } from "@tiptap/html"
import StarterKit from "@tiptap/starter-kit"
import { Color, TextStyle } from "@tiptap/extension-text-style"
import { normalizeTiptapContent } from '~/utils/tiptapContent'

const mainStore = useMainStore()

const {value} = defineProps({
    value: Object as PropType<JSONContent>
})

const rendered_html = computed(() => {
    if (!value) return
    const normalizedValue = normalizeTiptapContent(value) as JSONContent | Record<string, JSONContent>
    const document = 'type' in normalizedValue
        ? normalizedValue as JSONContent
        : normalizedValue[mainStore.active_locale]

    if (!document) return

    return generateHTML(document, [
            StarterKit,
            TextStyle,
            Color
    ])
})

</script>

<style scoped>
.rendered-content:deep(p) {min-height: 1lh;}
</style>
